<template>
  <!-- Display content if tabs is selected -->
  <div v-show="isSelected">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Tab",
  props: { isSelected: Boolean },
  data() {
    return {};
  },
};
</script>
